class LocalMediaServiceCtrl {
  public async openDisplayStream(
    constraints: MediaStreamConstraints
  ): Promise<MediaStream> {
    try {
      // if (DeviceService.isElectron) {
      //   const sourceId = await this.getSourceIdFromParent();

      //   return navigator.mediaDevices.getUserMedia({
      //     audio: false,
      //     video: {
      //       mandatory: {
      //         chromeMediaSource: "desktop",
      //         chromeMediaSourceId: sourceId,
      //       },
      //     } as MediaTrackConstraints,
      //   });
      // } else

      // @ts-ignore
      if (navigator.mediaDevices.getDisplayMedia) {
        // @ts-ignore
        return navigator.mediaDevices.getDisplayMedia(constraints);
        // @ts-ignore
      } else if (navigator.getDisplayMedia) {
        // @ts-ignore
        return navigator.getDisplayMedia(constraints);
      } else {
        throw new Error("get-display-media-not-supported");
      }
    } catch (ex) {
      throw ex;
    }
  }

  /*
  public getScreenStream(stream: MediaStream): IPublishedStream {
    try {
      const dummyStream: IPublishedStream = {
        type: StreamTypes.SCREEN,
        id: stream.id,
        originator: {
          endpoint: this.rtcClient.endpoint(),
          username: this.rtcClient.identity(),
        },
        mediaStream: stream,
        mute: async () => {},
        unmute: async () => {},
        replace: async () => {},
        updateMetadata: async () => {},
        updateVideoBitrate: async () => {},
        isMuted: (kind) =>
          kind === "audio"
            ? stream.getAudioTracks()[0]?.enabled
            : stream.getVideoTracks()[0]?.enabled,
        getMetadata: () => ({
          ...this.getStreamMetadata(stream),
          portraitMode: false,
          // used to lock screen share resource
          publishedAt: new Date().toISOString(),
        }),
      };

      //   this.screenStream = {
      //     stream: dummyStream,
      //     facingMode: "environment",
      //   };

      //   this.zone.runOutsideAngular(() =>
      stream.getVideoTracks()[0].addEventListener("ended", () => {
        //   debug("stream closed by user.");
        // this.closeScreenStream();
      });
      
      return dummyStream;
      //   );
    } catch (ex) {}
  }
  */

  public closeMediaStream(stream: MediaStream) {
    stream?.getTracks().forEach((track) => {
      track.stop?.();
    });
  }

  public getStreamMetadata(mediaStream: MediaStream) {
    const videoTrack = mediaStream?.getVideoTracks()[0];
    const audioTrack = mediaStream?.getAudioTracks()[0];

    return {
      video: videoTrack ? this.getTrackMetadata(videoTrack) : null,
      audio: audioTrack ? this.getTrackMetadata(audioTrack) : null,
    };
  }

  private getTrackMetadata(track: MediaStreamTrack) {
    try {
      return {
        id: track.id,
        settings: track.getSettings?.(),
        capabilities: track.getCapabilities?.(),
        constraints: track.getConstraints?.(),
      };
    } catch (ex) {
      return {
        id: "",
        settings: null,
        capabilities: null,
        constraints: null,
      };
    }
  }
}

export const LocalMediaService = new LocalMediaServiceCtrl();
